import React from "react";
import { Link } from "react-router-dom";
import "./CalendarPage.css"; 
// import IconSocalFurs from './SocalDate.jpg'

export default function CalendarPageNorcal() {


  return (

       <div className = "calendar-main-container">
 
            
            <div className = "calendar-container-1">
                      <header className = "calendar-header">Welcome to Our Norcal Calendar Page!</header>
                        {/* <img className="homepage-main-icon" src={IconSocalFursDate} alt="Socalfurs.com" /> */}
                      <p className = "calendar-p"> 
                        The SocalFurs calendar is your centralized hub for furry events happening 
                        throughout Southern California. Powered by wolps it features up to date 
                        listings of meetups and local gatherings. Our goal is to make it 
                        easy for furries to discover, share, and stay informed about events.
                        Whether you're new or a longtime member of the community. If you are new,
                        we have some inofrmation that can help you get introduced to our furry
                        community:
                        <Link to="/events"> Newcomers: Attending A Furry Event</Link>
                        <p></p>
                        <p className = "calendar-p" >You can also join our telegram groups below and get more information about events. Joining
                          <a href="https://telegram.org/"> Telegram</a> is highly reccomended!
                          <ul>
                            <li><a href = "https://t.me/NorCalFursCalendar">Norcal Furs Telegram Calendar Channel</a></li>
                          </ul>
                        
                        </p>
                      
                        </p>

          
                     
                      
                      
            </div>
            <div className = "calendar-container">
                <div className = "calendar-embed-container">
                    <iframe
                    title="Furry Events Calendar"
                    src="https://calendar.google.com/calendar/embed?src=195e34eee586838f75b0f7dec4c225dbc5b730763e33dec43beee1d5d4e2aba9%40group.calendar.google.com&ctz=America%2FLos_Angeles"
                    className="calendar-src"
                     frameBorder="0"
                    ></iframe>
                </div>
            
            </div>
              <div className = "space"></div>
              <p className = "calendar-p"> 
                              <button><a href ="https://calendar.google.com/calendar/u/0?cid=MTk1ZTM0ZWVlNTg2ODM4Zjc1YjBmN2RlYzRjMjI1ZGJjNWI3MzA3NjNlMzNkZWM0M2JlZWUxZDVkNGUyYWJhOUBncm91cC5jYWxlbmRhci5nb29nbGUuY29t">
                                Subscribe To Our Google Calendar!</a></button></p>

        </div>

         
  );
}
